import * as PIXI from "pixi.js";
import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { ControlConstants } from "../constant/ControlConstants";
import { TextFieldProperties } from "./TextFieldProperties";
/**
 * ClockProperties.ts
 */
export class ClockProperties extends AbstractViewProperties {
    constructor(fontStyle) {
        super();
        this.fontStyle = fontStyle;
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.updateInterval = 10000;
        this.timeFieldProperties = new TextFieldProperties(this.fontStyle, null, null, ControlConstants.RIGHT, ControlConstants.CENTER, new PIXI.Point(500, 60));
        if (this.horizontalAlign) {
            this.timeFieldProperties.horizontalAlign = this.horizontalAlign;
        }
    }
    equals(other) {
        return super.equals(other) &&
            (this.backgroundProperties.equals(other.backgroundProperties)) &&
            (this.timeFieldProperties.equals(other.timeFieldProperties)) &&
            (this.updateInterval === other.updateInterval);
    }
}
//# sourceMappingURL=ClockProperties.js.map